import axios from 'axios'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function audit({ action_performed }) {
  try {
    return await axios.post(`${LEADS_ENDPOINT}/audit`, { action_performed })
  } catch {
    throw new Error()
  }
}
